<div class="du-mail-popup">
    <div class="d-flex align-items-center justify-content-between du-mail-popup-header-bg">
        <div class="du-mail-popup-header">Save as Template</div>
        <mat-icon class="du-mail-popUp-close" (click)="popUpClose()">close</mat-icon>
    </div>
    <div class="du-mail-popup-container">
        <div>Save exisiting mail as Template</div>

        <div class="du-mail-input-container">
            <label class="du-mail-label">Template name</label>
            <input type="text" [(ngModel)]="templateName" class="du-mail-input" placeholder="Enter template name" />
        </div>

        <div class="du-mail-input-container">
            <mat-form-field style="width: 100%" appearance="fill" class="matFformFieldConfig">
                <mat-label>Choose Brand</mat-label>
                <mat-select [(ngModel)]="selectedBrand">
                    <mat-option style="font-family: 'Poppins';" *ngFor="let brand of brands" [value]="brand.brand_key"
                        [title]="brand.brand_name">
                        {{ brand.brand_name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="du-mail-input-container">
            <label class="du-mail-label">Template Description</label>
            <textarea [(ngModel)]="templateDescription" class="du-mail-input"
                placeholder="Enter description"></textarea>
        </div>

        <!-- Save Button -->
        <div class="du-mail-footer">
            <button class="du-mail-save-btn" (click)="saveTemplate()">Save</button>
        </div>
    </div>
</div>